import { IClasse } from './classe.model';
import { IMatiereEcole } from './matiere.model';
import { IProfesseur } from './professeur.model';

export interface ICalendarEntry {
  id?: string;
  professeurs?: IProfesseur[] | null;
  matiere?: IMatiereEcole;
  classe?: IClasse;
  classeId?: string;
  anneeScolaireId?: string;
  jour?: string;
  heureDebut?: string;
  heureFin?: string;
  createdDate?: string;
}

export const defaultValue: Readonly<ICalendarEntry> = {
  id: null,
  professeurs: [],
  matiere: null,
  classe: null,
  classeId: null,
  jour: '',
  heureDebut: '',
  heureFin: '',
  createdDate: '',
  anneeScolaireId: null,
};
